window.VH = window.VH === undefined ? {} : window.VH;

VH.OrderForm = {
    addFieldsContainer : null,
    objectInput : null,
    ddEquipmentType : null,
    ddState : null,
    form : null,
    btSubmit : null,

    isResourceCounter : function isResourceCounter() {
        let _t = VH.OrderForm;
        return parseInt($(':selected', _t.ddEquipmentType).data('show-counters')) > 0;
    },

    checkEquipmentCountersField : function checkEquipmentCountersField()
    {
        let _t = VH.OrderForm,
            container = $('.equipment_type_resource_counter');

        if (_t.isResourceCounter()) {
            container.show();
        } else {
            container.hide();
        }
    },

    checkStateField : function checkStateField()
    {
        let _t = VH.OrderForm,
            container = $('.reasonsClosingContainer');

        if (_t.ddState.val() === '4') {
            container.show();
        } else {
            container.hide();
        }
    },


    initClientObject : function initClientObject() {
        let _t = VH.OrderForm,
            clientVisibleField = $('#fake-order--fake_client_code'),
            clientHiddenField = $('#order-client_code'),
            phoneField = $('#order-client_phone'),
            addressField = $('#order-address'),
            restnumField = $('#order-rest_num')
        ;

        _t.objectInput.on('relation.change', function (event, data) {
            /** @type {
             * {
             *  clientTitle: string,
             *  client_code: string,
             *  code: string,
             *  name: string,
             *  actual_address: string,
             *  rest_num: string,
             *  phone: string
             *  }
             * } sd **/
            let sd = data.selectData;

            // console.log(data);

            clientVisibleField.val(sd.clientTitle);
            clientHiddenField.val(sd.client_code);

            addressField.val(sd.actual_address);

            restnumField.val(sd.rest_num);

            if (phoneField.val() === '') {
                phoneField.val(sd.phone);
            }
        });

        _t.objectInput.on('relation.clear', function () {
            clientVisibleField.val('');
            clientHiddenField.val('');
            restnumField.val('');
            addressField.val('');
        });
    },

    updateAddFields : function updateAddFields(clientCode) {
        let _t = VH.OrderForm,
            orderId = _t.addFieldsContainer.data('order-id'),
            errors = _t.addFieldsContainer.data('errors'),
            post = _t.addFieldsContainer.data('post'),
            url = _t.addFieldsContainer.data('url')
        ;
        //console.log(['updateAddFields', clientCode, orderId, url]);
        if (clientCode) {
            $.post(url, {
                clientCode : clientCode,
                orderId : orderId ? orderId : null,
                errors : errors,
                post : post
            }, function (data) {
                //console.log(['updateAddFields get', data]);
                _t.addFieldsContainer.html(data);
                $('.afMasked').each(function() {
                    let t = $(this),
                        mask = t.data('mask');

                    if (mask !== undefined) {
                        t.inputmask({"mask" : mask});
                    }

                })
            });
        } else {
            _t.addFieldsContainer.html('');
        }
    },

    initAddFields : function initAddFields()
    {
        // console.log(['initAddFields']);
        let _t = VH.OrderForm;
        _t.addFieldsContainer = $('#addFieldsContainer');

        _t.objectInput.on('relation.change', function (event, data) {
            /** @type {
             * {
             *  clientTitle: string,
             *  client_code: string,
             *  code: string,
             *  name: string,
             *  actual_address: string,
             *  rest_num: string,
             *  phone: string
             *  }
             * } sd **/
            let sd = data.selectData;
            //console.log(['initAddFields relation.change', sd.client_code]);

            _t.updateAddFields(sd.client_code);
        });
        _t.objectInput.on('relation.clear', function () {
            _t.updateAddFields('');
        });

        _t.updateAddFields(_t.addFieldsContainer.data('client-code'));
    },

    init : function init()
    {
        let _t = VH.OrderForm;
        _t.form = $('#orderForm');
        _t.btSubmit = $('#orderSubmitButton');
        _t.form.on('beforeValidate', function() {
            _t.btSubmit.prop('disabled', true);
        });
        _t.form.on('afterValidate', function(event, messages, errorAttributes) {
            if (errorAttributes.length > 0) {
                _t.btSubmit.prop('disabled', false);
            }
        });
        // _t.form.on('beforeSubmit', function() {
        //     _t.btSubmit.prop('disabled', true);
        // });

        _t.objectInput = $('#order-client_object_code');

        _t.ddEquipmentType = $('#ddEquipmentType');
        _t.ddState = $('#ddState');

        _t.checkEquipmentCountersField();
        _t.ddEquipmentType.on('change', _t.checkEquipmentCountersField);

        _t.checkStateField();
        _t.ddState.on('change', _t.checkStateField);

        _t.initClientObject();

        _t.initAddFields();

        $('[data-toggle="tooltip"]').tooltip();

        // file kostyl
        setTimeout(function () {
            $('.kv-file-zoom').removeAttr('disabled');

            $('.file-footer-buttons').each(function () {
                let t = $(this),
                    url = t.closest('.file-preview-frame').data('zoom')
                ;

                t.append('<a href="' + decodeURIComponent(url) + '" target="_blank" class="btn btn-sm btn-default btn-outline-secondary"><i class="fas fa-print"></i></a>');
            });

        }, 1000);

    },

    whenStateIn : function whenStateIn (states)
    {
        for (let i = 0; i < states.length; i++) {
            if (parseInt(states[i]) === parseInt($('#ddState').val())) {
                return true;
            }
        }
        return false;
    },

    fromAppDate : function(value) {
        return '' + value.substring(6, 10) + value.substring(3, 5) + value.substring(0, 2)
            + value.substring(11, 13) + value.substring(14);
    },

    compareDates: function compareDates(value, messages, options, $form) {
        let _t = VH.OrderForm,
            tVal = _t.fromAppDate(value),
            $target,
            compareValue
        ;

        if (options.compareAttribute === undefined) {
            compareValue = options.compareValue;
        } else {
            $target = $('#' + options.compareAttribute);
            if (!$target.length) {
                $target = $form.find('[name="' + options.compareAttributeName + '"]');
            }
            compareValue = $target.val();
        }
        options.type = 'string';
        options.compareValue = _t.fromAppDate(compareValue);
        options.compareAttribute = undefined;
        return yii.validation.compare(tVal, messages, options, $form);
    }

};
